import React, { useContext } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faUser, faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { Link } from "wouter";

import { absURL } from '../utils';
import quizInstanceAdminStatusContext from '../context/quizInstanceAdminStatusContext';

import QuizAdminStartBtn from './QuizAdminStartBtn';
import QuizAdminEndBtn from './QuizAdminEndBtn';
import QuizAdminResultTimer from './QuizAdminResultTimer';

import QuizAdminStats from './QuizAdminStats';
import QuizAdminStatsPoll from './QuizAdminStatsPoll';
import QuizAdminStatsFreeText from './QuizAdminStatsFreeText';
import QuizAdminLeaderboard from './QuizAdminLeaderboard';

export default function QuizAdminResult() {

  const ctx = useContext(quizInstanceAdminStatusContext);
  const isStandingMode = !!ctx.quizInfo.config?.standingMode;
  let content = null;
  switch(ctx.quizInfo.type)
  {
    default:
    case "Quiz":
    case "Musicquiz":
      content = ctx.quizInfo.config?.competitionMode
        ? <QuizAdminLeaderboard />
        : <QuizAdminStats />;
      break;
    case "Poll":
      content = <QuizAdminStatsPoll />
      break;
    case "Free":
      content = <QuizAdminStatsFreeText />
      break;
  }

  return <>
    <Container fluid id="quizAdminResult" className="h-100">
      <Row id="quizAdminResultHeader" className="text-dark">
        {!ctx.quizInfo.completed && 
        <>
          <div className="mt-3 mr-3">
            <Link href={absURL(`/${ctx.quizAccessShortId}/admin`)}>
              <Button type="submit" variant="light">
                <FontAwesomeIcon icon={faChevronLeft} />
              </Button>
            </Link>
          </div>
          {!isStandingMode &&
            <div className="mt-3 mr-3">
              <QuizAdminStartBtn />
            </div>
          }
          <div className="mt-3 mr-3" >
            <QuizAdminEndBtn />
          </div>
          {/* A standing instance has no ends_at (no duration to count down),
              so QuizAdminResultTimer would treat it as already elapsed and
              immediately auto-end the instance via onElapsed. */}
          {!isStandingMode &&
            <div className="mt-3 mr-3">
              <QuizAdminResultTimer />
            </div>
          }
        </>
        }
        <div className="mt-3 ml-2">
          <div style={{marginTop: "-5px"}}>

            <div>
              <FontAwesomeIcon 
                icon={faUser} 
                style={{color: "#7B7C6A"}} 
                className="mr-1" />
              <span>Deltagare som svarat: </span>
              <span className="float-right pl-2">
                {ctx.quizInfo.participantAnsweredCount} / {ctx.quizInfo.participantTotalCount}
              </span>
            </div>

            {ctx.quizInfo.type === "Free" && 
              <div>
                <FontAwesomeIcon 
                  icon={faPaperPlane} 
                  style={{color: "#7B7C6A"}} 
                  className="mr-1" />
                <span>Inskickade svar: </span>
                <span className="float-right pl-2">
                  {ctx.quizInfo.answerTotalCount}
                </span>
              </div>
            }
          </div>
        </div>
      </Row>
      <Row id="quizAdminResultContent">
        {content}
      </Row>
    </Container>
  </>
};